import { definePreset } from '@primeuix/themes'
import Aura from '@primeuix/themes/aura'

const CustomPreset = definePreset(Aura, {
    primitive: {
        blue: {
            50: '#effaff',
            100: '#def3ff',
            200: '#b6eaff',
            300: '#76dbff',
            400: '#2ec9ff',
            500: '#02afef',
            600: '#008fd2',
            700: '#0073aa',
            800: '#00618c',
            900: '#074f73',
            950: '#04334d',
        },
    },
    semantic: {
        primary: {
            50: '#effaff',
            100: '#def3ff',
            200: '#b6eaff',
            300: '#76dbff',
            400: '#2ec9ff',
            500: '#02afef',
            600: '#008fd2',
            700: '#0073aa',
            800: '#00618c',
            900: '#074f73',
            950: '#04334d',
        },
    },
})

export default CustomPreset
